import { DataItemType, DataType } from "components/EffectSearch/EffectSearch";

const transactionExpirationTemplatesItems: DataItemType[] = [
  {
    label: "atStaticDate",
    code: "to_date({{DATE}})",
    codeRegexMatcher: /^to_date\('.*?'\)$/g,

    parameter: "{{DATE}}",
    parameterType: "datetime",
  },
  {
    label: "15DaysFromTransaction",
    code: "add_days_to_date(transaction.purchasedAt, 15)",
    codeRegexMatcher: /^add_days_to_date\(transaction.purchasedAt,\s?\d*\)$/g,
  },
  {
    label: "3MonthsFromTransaction",
    code: "add_months_to_date(transaction.purchasedAt, 3)",
    codeRegexMatcher: /^add_months_to_date\(transaction.purchasedAt,\s?\d*\)$/g,
  },
  {
    label: "1YearFromTransaction",
    code: "add_years_to_date(transaction.purchasedAt, 1)",
    codeRegexMatcher: /^add_years_to_date\(transaction.purchasedAt,\s?\d*\)$/g,
  },
  {
    label: "neverExpires",
    code: "never_expires",
    codeRegexMatcher: /^never_expires$/g,
    onSelect: function (): DataItemType {
      return this;
    },
    hideCode: true,
  },
];

const transactionPendingTemplatesItems: DataItemType[] = [
  {
    label: "atStaticDate",
    code: "to_date({{DATE}})",
    codeRegexMatcher: /^to_date\('.*?'\)$/g,
    parameter: "{{DATE}}",
    parameterType: "datetime",
  },
  {
    label: "15DaysFromTransaction",
    code: "add_days_to_date(transaction.purchasedAt, 15)",
    codeRegexMatcher: /^add_days_to_date\(transaction.purchasedAt,\s?\d*\)$/g,
  },
  {
    label: "3MonthsFromTransaction",
    code: "add_months_to_date(transaction.purchasedAt, 3)",
    codeRegexMatcher: /^add_months_to_date\(transaction.purchasedAt,\s?\d*\)$/g,
  },
  {
    label: "1YearFromTransaction",
    code: "add_years_to_date(transaction.purchasedAt, 1)",
    codeRegexMatcher: /^add_years_to_date\(transaction.purchasedAt,\s?\d*\)$/g,
  },
  {
    label: "noPending",
    code: "no_pending",
    codeRegexMatcher: /^no_pending$/g,
    onSelect: function (): DataItemType {
      return this;
    },
    hideCode: true,
  },
];

const transactionVariablesItems: DataItemType[] = [
  {
    label: "currentDate",
    code: "executionContext.processedAt",
    codeRegexMatcher: /^executionContext.processedAt$/g,
  },
  {
    label: "transactionDocumentDate",
    code: "transaction.purchasedAt",
    codeRegexMatcher: /^transaction.purchasedAt$/g,
  },
  {
    label: "memberCustomAttribute",
    code: "to_date(agg(customer.labels).getLabelValue('{{LABEL_KEY}}'))",
    codeRegexMatcher:
      /^to_date\(agg\(customer.labels\).getLabelValue\('.*?'\)\)$/g,
    parameter: "{{LABEL_KEY}}",
    parameterType: "text",
    dialogTitle: "memberCustomAttribute",
    dialogDescription: "dialogDescriptionMemberCustomAttributes",
  },
  {
    label: "transactionCustomAttribute",
    code: "to_date(agg(transaction.labels).getLabelValue('{{LABEL_KEY}}'))",
    codeRegexMatcher:
      /^to_date\(agg\(transaction.labels\).getLabelValue\('.*?'\)\)$/g,
    parameter: "{{LABEL_KEY}}",
    parameterType: "text",
    dialogTitle: "transactionCustomAttribute",
    dialogDescription: "dialogDescriptionTransactionCustomAttributes",
  },
];

export const transactionBasedExpirationData: DataType[] = [
  {
    name: "templates",
    items: transactionExpirationTemplatesItems,
  },
  {
    name: "variables",
    items: transactionVariablesItems,
  },
];

export const transactionBasedPendingData: DataType[] = [
  {
    name: "templates",
    items: transactionPendingTemplatesItems,
  },
  {
    name: "variables",
    items: transactionVariablesItems,
  },
];

export const eventExpirationTemplatesItems: DataItemType[] = [
  {
    label: "atStaticDate",
    code: "to_date({{DATE}})",
    codeRegexMatcher: /^to_date\('.*?'\)$/g,
    parameter: "{{DATE}}",
    parameterType: "datetime",
  },
  {
    label: "15DaysFromEvent",
    code: "add_days_to_date(event.eventDate, 15)",
    codeRegexMatcher: /^add_days_to_date\(event.eventDate,\s?\d*\)$/g,
  },
  {
    label: "3MonthsFromEvent",
    code: "add_months_to_date(event.eventDate, 3)",
    codeRegexMatcher: /^add_months_to_date\(event.eventDate,\s?\d*\)$/g,
  },
  {
    label: "1YearFromEvent",
    code: "add_years_to_date(event.eventDate, 1)",
    codeRegexMatcher: /^add_years_to_date\(event.eventDate,\s?\d*\)$/g,
  },
  {
    label: "neverExpires",
    code: "never_expires",
    codeRegexMatcher: /^never_expires$/g,
    onSelect: function (): DataItemType {
      return this;
    },
    hideCode: true,
  },
];

export const eventPendingTemplatesItems: DataItemType[] = [
  {
    label: "atStaticDate",
    code: "to_date({{DATE}})",
    codeRegexMatcher: /^to_date\('.*?'\)$/g,
    parameter: "{{DATE}}",
    parameterType: "datetime",
  },
  {
    label: "15DaysFromEvent",
    code: "add_days_to_date(event.eventDate, 15)",
    codeRegexMatcher: /^add_days_to_date\(event.eventDate,\s?\d*\)$/g,
  },
  {
    label: "3MonthsFromEvent",
    code: "add_months_to_date(event.eventDate, 3)",
    codeRegexMatcher: /^add_months_to_date\(event.eventDate,\s?\d*\)$/g,
  },
  {
    label: "1YearFromEvent",
    code: "add_years_to_date(event.eventDate, 1)",
    codeRegexMatcher: /^add_years_to_date\(event.eventDate,\s?\d*\)$/g,
  },
  {
    label: "noPending",
    code: "no_pending",
    codeRegexMatcher: /^no_pending$/g,
    onSelect: function (): DataItemType {
      return this;
    },
    hideCode: true,
  },
];

const eventVariablesItems: DataItemType[] = [
  {
    label: "currentDate",
    code: "executionContext.processedAt",
    codeRegexMatcher: /^executionContext.processedAt$/g,
  },
  {
    label: "eventDate",
    code: "event.eventDate",
    codeRegexMatcher: /^event.eventDate$/g,
  },
  {
    label: "memberCustomAttribute",
    code: "to_date(agg(customer.labels).getLabelValue('{{LABEL_KEY}}'))",
    codeRegexMatcher:
      /^to_date\(agg\(customer.labels\).getLabelValue\('.*?'\)\)$/g,
    parameter: "{{LABEL_KEY}}",
    parameterType: "text",
    dialogTitle: "memberCustomAttribute",
    dialogDescription: "dialogDescriptionMemberCustomAttributes",
  },
];

export const internalEventBasedExpirationData: DataType[] = [
  {
    name: "templates",
    items: eventExpirationTemplatesItems,
  },
  {
    name: "variables",
    items: eventVariablesItems,
  },
];

export const internalEventBasedPendingData: DataType[] = [
  {
    name: "templates",
    items: eventPendingTemplatesItems,
  },
  {
    name: "variables",
    items: eventVariablesItems,
  },
];

const achievementExpirationTemplatesItems: DataItemType[] = [
  {
    label: "atStaticDate",
    code: "to_date({{DATE}})",
    codeRegexMatcher: /^to_date\('.*?'\)$/g,
    parameter: "{{DATE}}",
    parameterType: "datetime",
  },
  {
    label: "neverExpires",
    code: "never_expires",
    codeRegexMatcher: /^never_expires$/g,
    onSelect: function (): DataItemType {
      return this;
    },
    hideCode: true,
  },
];

const achievementPendingTemplatesItems: DataItemType[] = [
  {
    label: "atStaticDate",
    code: "to_date({{DATE}})",
    codeRegexMatcher: /^to_date\('.*?'\)$/g,
    parameter: "{{DATE}}",
    parameterType: "datetime",
  },
  {
    label: "noPending",
    code: "no_pending",
    codeRegexMatcher: /^no_pending$/g,
    onSelect: function (): DataItemType {
      return this;
    },
    hideCode: true,
  },
];

const achievementVariablesItems: DataItemType[] = [
  {
    label: "currentDate",
    code: "executionContext.processedAt",
    codeRegexMatcher: /^executionContext.processedAt$/g,
  },
  {
    label: "tierReachedDate",
    code: "customer.levelAchievementDate",
    codeRegexMatcher: /^customer.levelAchievementDate$/g,
  },
  {
    label: "memberCustomAttribute",
    code: "to_date(agg(customer.labels).getLabelValue('{{LABEL_KEY}}'))",
    codeRegexMatcher:
      /^to_date\(agg\(customer.labels\).getLabelValue\('.*?'\)\)$/g,
    parameter: "{{LABEL_KEY}}",
    parameterType: "text",
    dialogTitle: "memberCustomAttribute",
    dialogDescription: "dialogDescriptionMemberCustomAttributes",
  },
];

export const achievementBasedExpirationData: DataType[] = [
  {
    name: "templates",
    items: achievementExpirationTemplatesItems,
  },
  {
    name: "variables",
    items: achievementVariablesItems,
  },
];

export const achievementBasedPendingData: DataType[] = [
  {
    name: "templates",
    items: achievementPendingTemplatesItems,
  },
  {
    name: "variables",
    items: achievementVariablesItems,
  },
];

export const customEventBasedVariables: DataItemType[] = [
  {
    label: "currentDate",
    code: "executionContext.processedAt",
    codeRegexMatcher: /^executionContext.processedAt$/g,
  },
  {
    label: "eventDate",
    code: "event.eventDate",
    codeRegexMatcher: /^event.eventDate$/g,
  },
  {
    label: "memberCustomAttribute",
    code: "to_date(agg(customer.labels).getLabelValue('{{LABEL_KEY}}'))",
    codeRegexMatcher:
      /^to_date\(agg\(customer.labels\).getLabelValue\('.*?'\)\)$/g,
    parameter: "{{LABEL_KEY}}",
    parameterType: "text",
    dialogTitle: "memberCustomAttribute",
    dialogDescription: "dialogDescriptionMemberCustomAttributes",
  },
];

const birthdayExpirationTemplatesItems: DataItemType[] = [
  {
    label: "atStaticDate",
    code: "to_date({{DATE}})",
    codeRegexMatcher: /^to_date\('.*?'\)$/g,
    parameter: "{{DATE}}",
    parameterType: "datetime",
  },
  {
    label: "neverExpires",
    code: "never_expires",
    codeRegexMatcher: /^never_expires$/g,
    onSelect: function (): DataItemType {
      return this;
    },
    hideCode: true,
  },
];

const birthdayPendingTemplatesItems: DataItemType[] = [
  {
    label: "atStaticDate",
    code: "to_date({{DATE}})",
    codeRegexMatcher: /^to_date\('.*?'\)$/g,
    parameter: "{{DATE}}",
    parameterType: "datetime",
  },
  {
    label: "noPending",
    code: "no_pending",
    codeRegexMatcher: /^no_pending$/g,
    onSelect: function (): DataItemType {
      return this;
    },
    hideCode: true,
  },
];

const birthdayVariablesItems: DataItemType[] = [
  {
    label: "currentDate",
    code: "executionContext.processedAt",
    codeRegexMatcher: /^executionContext.processedAt$/g,
  },
  {
    label: "memberCustomAttribute",
    code: "to_date(agg(customer.labels).getLabelValue('{{LABEL_KEY}}'))",
    codeRegexMatcher:
      /^to_date\(agg\(customer.labels\).getLabelValue\('.*?'\)\)$/g,
    parameter: "{{LABEL_KEY}}",
    parameterType: "text",
    dialogTitle: "memberCustomAttribute",
    dialogDescription: "dialogDescriptionMemberCustomAttributes",
  },
];

export const birthdayCampaignBasedExpirationData: DataType[] = [
  {
    name: "templates",
    items: birthdayExpirationTemplatesItems,
  },
  {
    name: "variables",
    items: birthdayVariablesItems,
  },
];

export const birthdayCampaignBasedPendingData: DataType[] = [
  {
    name: "templates",
    items: birthdayPendingTemplatesItems,
  },
  {
    name: "variables",
    items: birthdayVariablesItems,
  },
];
